import React, { Component } from "react";
import SlickWrap from "./SlickWrap";
import SlickMobileWrap from "./SlickMobileWrap";

import { computeListData, mobileCheck } from "../utility/global";

export default class SelectSwitch extends Component {
    constructor(props) {
        super(props);
        // 不要在這裡呼叫 this.setState()！
        this.state = {
            selectedState: [],
            excludeCategoryList: [],
            excludeItemList: [],
            isMobile: false,
        };
        this.updateSelectedState = this.updateSelectedState.bind(this);
    }
    initialSelectedState() {
        const {
            selectedCategoryIndex,
            SelectedCategoryFacets,
            setSlideArray,
            updateListDataJson,
            planningData,
        } = this.props;
        // console.log(SelectedCategoryFacets);
        let selectData = [];

        SelectedCategoryFacets.forEach((item, index) => {
            let itemData = {
                showIndex: 0,
                realJsonIndex: 0,
            };

            selectData[index] = itemData;
        });

        this.setState({
            selectedState: selectData,
        });
        let newListData = computeListData(
            planningData.category[selectedCategoryIndex],
            selectData
        );
        setSlideArray(selectData);
        updateListDataJson(newListData);
        this.updateFilterState();
    }
    updateSelectedState(FacetsIndex, current) {
        const {
            setSlideArray,
            SelectedCategoryFacets,
            updateListDataJson,
            updateIsSendDesignCode,
            selectedCategoryIndex,
            planningData,
            // gotoRow,
            isSendDesignCode,
            isReset,
            selectedState,
        } = this.props;

        // 如果是輸入設計代碼切換 slide 的直接拿 props 當回傳值就好
        // 但最後要把 isSendDesignCode 更新成 false，不然點擊 slide箭頭不能滑動
        if (isSendDesignCode && !isReset) {
            this.setState({
                selectedState: selectedState,
            });
            let newListData = computeListData(
                planningData.category[selectedCategoryIndex],
                selectedState
            );

            setSlideArray(selectedState);
            updateListDataJson(newListData);
            updateIsSendDesignCode(false);
        } else {
            if (!this.state) {
                this.initialSelectedState();
            }
            let { selectedState } = this.state;
            selectedState = Object.assign(selectedState);
            // console.log(selectedState)
            selectedState[FacetsIndex].showIndex = current;

            // console.log(SelectedCategoryFacets[FacetsIndex].itemList.length);
            let selectedCategoryFacetsLength =
                SelectedCategoryFacets[FacetsIndex].itemList.length;
            let slickCurrentJsonIndexLength = document.getElementsByClassName(
                "slick-center slick-current"
            ).length;

            for (let i = 0; i < slickCurrentJsonIndexLength; i++) {
                const element = document.getElementsByClassName(
                    "slick-center slick-current"
                )[i];
                const realJsonDataIndex = parseInt(
                    element.childNodes[0].childNodes[0].dataset.jsonIndex
                );
                // 因為 slick 數量不足會多補組數，補的 index 會超過原本資料的長度，所以要扣掉
                if (FacetsIndex === i) {
                    if (realJsonDataIndex >= selectedCategoryFacetsLength) {
                        selectedState[i].realJsonIndex =
                            realJsonDataIndex - selectedCategoryFacetsLength;
                        if (
                            selectedState[i].realJsonIndex >=
                            selectedCategoryFacetsLength
                        ) {
                            selectedState[i].realJsonIndex =
                                selectedState[i].realJsonIndex -
                                selectedCategoryFacetsLength;
                        }
                    } else {
                        selectedState[i].realJsonIndex = realJsonDataIndex;
                    }
                }
            }

            //  當滑動第一個 slide 的時候其他 slide 要回到初始值
            if (FacetsIndex === 0) {
                selectedState.forEach((item, index) => {
                    if (index !== 0) {
                        item.showIndex = 0;
                        item.realJsonIndex = 0;
                    }
                });
            }

            // 萊特書桌當沒有選擇桌上架的時候不能選層板
            if (selectedCategoryIndex === 3 && FacetsIndex === 3) {
                if (selectedState[3].realJsonIndex === 2) {
                    selectedState[4].showIndex = 0;
                    selectedState[4].realJsonIndex = 0;
                }
            }

            this.setState({
                selectedState: selectedState,
            });

            // console.log(planningData.category[selectedCategoryIndex], selectedState);
            let newListData = computeListData(
                planningData.category[selectedCategoryIndex],
                selectedState
            );

            // 先更新這層的 selectedState
            // 這邊把現在變化的參數接到
            // 更新給 reducer
            setSlideArray(selectedState);
            updateListDataJson(newListData);
        }
    }

    updateFilterState() {
        let excludeCategoryList = [];
        let excludeItemList = [];

        const {
            // isGoToTheSamePosition,
            // isReset,
            planningData,
            selectedCategoryIndex,
        } = this.props;
        const { selectedState } = this.state;

        // 選到的分類
        let SelectedCategory = planningData.category[selectedCategoryIndex];

        SelectedCategory.categoryList.forEach((cateItem, cateIndex) => {
            if (selectedState[cateIndex] !== undefined) {
                if (
                    selectedState[cateIndex].showIndex >
                    cateItem.itemList.length
                ) {
                    selectedState[cateIndex].showIndex = 0;
                }
                if (
                    cateItem.itemList[selectedState[cateIndex].showIndex] !==
                    undefined
                ) {
                    excludeCategoryList.push(
                        cateItem.itemList[selectedState[cateIndex].showIndex]
                            .excludeCategoryList
                    );
                    excludeItemList.push(
                        cateItem.itemList[selectedState[cateIndex].showIndex]
                            .excludeItemList
                    );
                }
            }
        });

        this.setState({
            excludeCategoryList: excludeCategoryList,
            excludeItemList: excludeItemList,
        });
    }

    componentDidUpdate(prevProps) {
        // console.log(prevProps)
        if (
            this.props.SelectedCategoryFacets !==
                prevProps.SelectedCategoryFacets &&
            !this.props.isSendDesignCode
        ) {
            this.initialSelectedState();
        }

        if (
            JSON.stringify(this.props.selectedCategoryIndex) !==
            JSON.stringify(prevProps.selectedCategoryIndex)
        ) {
            this.initialSelectedState();
        }

        // 預計把例外處理放在這邊
        if (
            JSON.stringify(this.props.selectedState) !==
            JSON.stringify(prevProps.selectedState)
        ) {
            this.updateFilterState();
        }
    }

    componentDidMount() {
        let isMobile = mobileCheck();
        this.initialSelectedState();

        if (isMobile) {
            this.setState({
                isMobile: true,
            });
        }
    }
    render() {
        const {
            SelectedCategoryFacets,
            isReset,
            isGoToTheSamePosition,
            selectedState,
            updateSamePosition,
            resetSelected,
            updateGoToRow,
            gotoRow,
            isSendDesignCode,
        } = this.props;
        const { isMobile, excludeCategoryList, excludeItemList } = this.state;
        return (
            <div className="col-12 slideWrap border border-1 my-3">
                {!isMobile ? (
                    // 桌機
                    <div className="d-none d-lg-flex row">
                        {SelectedCategoryFacets.map(
                            (FacetsItem, FacetsIndex) => {
                                // console.log(FacetsItem);
                                return (
                                    <div
                                        className="row"
                                        key={
                                            FacetsItem.itemTypeName +
                                            FacetsIndex
                                        }>
                                        {!(
                                            JSON.stringify(
                                                excludeCategoryList
                                            ).indexOf(FacetsItem.itemType) ===
                                            -1
                                        ) ? null : (
                                            <div className="col-2 d-flex slide__title__wrap">
                                                <span className="slide__title">
                                                    {FacetsItem.itemTypeName}
                                                </span>
                                                <div className="slide__account">
                                                    {!selectedState
                                                        ? null
                                                        : !selectedState[
                                                              FacetsIndex
                                                          ]
                                                        ? null
                                                        : selectedState[
                                                              FacetsIndex
                                                          ].showIndex + 1}
                                                    <span> / </span>
                                                    {FacetsItem.itemList.length}
                                                </div>
                                            </div>
                                        )}
                                        {!(
                                            JSON.stringify(
                                                excludeCategoryList
                                            ).indexOf(FacetsItem.itemType) ===
                                            -1
                                        ) ? null : (
                                            <div className="col-10">
                                                {/* 把 分類組出來 然後針對分類做例外排除 */}
                                                <SlickWrap
                                                    // excludeCategoryList={excludeCategoryList}
                                                    excludeItemList={
                                                        excludeItemList
                                                    }
                                                    selectedState={
                                                        selectedState
                                                    }
                                                    slickGoToRow={
                                                        selectedState[
                                                            FacetsIndex
                                                        ]
                                                    }
                                                    FacetsIndex={FacetsIndex}
                                                    FacetsItemLength={
                                                        FacetsItem.itemList
                                                            .length
                                                    }
                                                    slickData={
                                                        FacetsItem.itemList
                                                    }
                                                    updateSelectedState={
                                                        this.updateSelectedState
                                                    }
                                                    isReset={isReset}
                                                    isSendDesignCode={
                                                        isSendDesignCode
                                                    }
                                                    resetSelected={
                                                        resetSelected
                                                    }
                                                    isGoToTheSamePosition={
                                                        isGoToTheSamePosition
                                                    }
                                                    updateSamePosition={
                                                        updateSamePosition
                                                    }
                                                    updateGoToRow={
                                                        updateGoToRow
                                                    }
                                                    gotoRow={gotoRow}
                                                />
                                            </div>
                                        )}
                                    </div>
                                );
                            }
                        )}
                    </div>
                ) : (
                    // 手機
                    <div className="d-lg-none">
                        {SelectedCategoryFacets.map(
                            (FacetsItem, FacetsIndex) => {
                                return (
                                    <div
                                        className="row"
                                        key={
                                            FacetsItem.itemTypeName +
                                            FacetsIndex
                                        }>
                                        {!(
                                            JSON.stringify(
                                                excludeCategoryList
                                            ).indexOf(FacetsItem.itemType) ===
                                            -1
                                        ) ? null : (
                                            <div className="col-2 d-flex slide__title__wrap">
                                                <span className="slide__title">
                                                    {FacetsItem.itemTypeName}
                                                </span>
                                                <div className="slide__account">
                                                    {!selectedState
                                                        ? null
                                                        : !selectedState[
                                                              FacetsIndex
                                                          ]
                                                        ? null
                                                        : selectedState[
                                                              FacetsIndex
                                                          ].showIndex + 1}
                                                    <span> / </span>
                                                    {FacetsItem.itemList.length}
                                                </div>
                                            </div>
                                        )}
                                        {!(
                                            JSON.stringify(
                                                excludeCategoryList
                                            ).indexOf(FacetsItem.itemType) ===
                                            -1
                                        ) ? null : (
                                            <div className="col-10">
                                                <SlickMobileWrap
                                                    // excludeCategoryList={excludeCategoryList}
                                                    excludeItemList={
                                                        excludeItemList
                                                    }
                                                    selectedState={
                                                        selectedState
                                                    }
                                                    FacetsIndex={FacetsIndex}
                                                    FacetsItemLength={
                                                        FacetsItem.itemList
                                                            .length
                                                    }
                                                    isSendDesignCode={
                                                        isSendDesignCode
                                                    }
                                                    slickGoToRow={
                                                        selectedState[
                                                            FacetsIndex
                                                        ]
                                                    }
                                                    slickData={
                                                        FacetsItem.itemList
                                                    }
                                                    updateSelectedState={
                                                        this.updateSelectedState
                                                    }
                                                    isReset={isReset}
                                                    resetSelected={
                                                        resetSelected
                                                    }
                                                    isGoToTheSamePosition={
                                                        isGoToTheSamePosition
                                                    }
                                                    updateSamePosition={
                                                        updateSamePosition
                                                    }
                                                    updateGoToRow={
                                                        updateGoToRow
                                                    }
                                                    gotoRow={gotoRow}
                                                />
                                            </div>
                                        )}
                                    </div>
                                );
                            }
                        )}
                    </div>
                )}
            </div>
        );
    }
}
